import EmbedFormModal from './EmbedFormModal';

export default EmbedFormModal;
